__turbopack_context__.v({
  "bottomLinksWideScreen": "VisualRoot-module-scss-module__-YyeAq__bottomLinksWideScreen",
  "compass": "VisualRoot-module-scss-module__-YyeAq__compass",
  "compass__north": "VisualRoot-module-scss-module__-YyeAq__compass__north",
  "description": "VisualRoot-module-scss-module__-YyeAq__description",
  "gradient": "VisualRoot-module-scss-module__-YyeAq__gradient",
  "image": "VisualRoot-module-scss-module__-YyeAq__image",
  "infoWideScreen": "VisualRoot-module-scss-module__-YyeAq__infoWideScreen",
  "mask": "VisualRoot-module-scss-module__-YyeAq__mask",
  "queueBox": "VisualRoot-module-scss-module__-YyeAq__queueBox",
  "rightBlock": "VisualRoot-module-scss-module__-YyeAq__rightBlock",
  "rightBlock__tabs": "VisualRoot-module-scss-module__-YyeAq__rightBlock__tabs",
  "title": "VisualRoot-module-scss-module__-YyeAq__title",
  "wrapper": "VisualRoot-module-scss-module__-YyeAq__wrapper",
});
